// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__RBKKn","title":"Advt_title__G-UxD","wiggle":"Advt_wiggle__Janot","qrsWrapper":"Advt_qrsWrapper__819UN","qrCode":"Advt_qrCode__eojE4"};